import { injectReducer } from '../../store/reducers'
import { isLoggedIn } from 'utils/auth'
import {endlessAisleFormReducer} from './modules/customerInterests'

export default (store) => ({
  path: 'endless-aisle',
  onEnter: isLoggedIn(store),
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const CustomerInterest = require('./containers/CustomerInterestsContainer').default
      const {customerInterestsFilterReducer, customerInterestsReducer,
        loadStoreOptionsReducer, endlessAisleFormReducer, selectedEndlessAisleColValuesReducer
         } = require('./modules/customerInterests')

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, {key: 'customerInterestsFilter', reducer: customerInterestsFilterReducer})
      injectReducer(store, {key: 'customerInterests', reducer: customerInterestsReducer})
      injectReducer(store, {key: 'storeOptions', reducer: loadStoreOptionsReducer})
      injectReducer(store, {key: 'endlessAisleInterestForm', reducer: endlessAisleFormReducer})
      injectReducer(store, {key: 'endlessAisleInterestColumns', reducer: selectedEndlessAisleColValuesReducer})
      /*  Return getComponent   */
      cb(null, CustomerInterest)

      /* Webpack named bundle   */
    }, 'HomeView')
  }
})



// WEBPACK FOOTER //
// ./src/routes/CustomerInterests/index.js